module.exports = __webpack_public_path__ + "static/jacksonville-urban-body-1-60cdecf553c36f39233010329d836196.jpg";